import { client } from "../src/sanityClient"

export async function getPhotos() {
  return client.fetch(`
    *[_type == "gallery"] | order(name asc){
      _id,
      name,
      "img": images.asset->url
    }
  `)
}